import { StrictMode, ReactNode } from 'react'
import * as ReactDOM from 'react-dom/client'
import { BrowserRouter, MemoryRouter } from 'react-router-dom'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers'

import App from './app/app'

import { Provider } from 'react-redux'
import { store } from './app/store/root'
import { ThemeProvider } from '@mui/material'
import { theme } from '@sendhub/shared-ui'
import { getEmbedConfig } from './utils/embed-config'

const embed = getEmbedConfig()

const rootElement = document.getElementById(embed.rootId)
if (!rootElement) throw new Error(`Integrations: mount element #${embed.rootId} not found`)

function Router({ children }: { children: ReactNode }) {
  // Memory routing starts from wherever the host page currently is, so a deep
  // link such as /integrations/jazzhr still opens the right screen.
  if (embed.routerMode === 'memory')
    return <MemoryRouter initialEntries={[window.location.pathname + window.location.search]}>{children}</MemoryRouter>
  return <BrowserRouter>{children}</BrowserRouter>
}

const root = ReactDOM.createRoot(rootElement)
root.render(
  <Provider store={store}>
    <StrictMode>
      <Router>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <App />
          </LocalizationProvider>
        </ThemeProvider>
      </Router>
    </StrictMode>
  </Provider>
)
